// import FileDropzone from 'vue-file-dropzone';
import heic2any from 'heic2any';
import Compressor from 'compressorjs';
import Accordion from '../../Accordion/Accordion.vue';
import Loader from '../../Loader/Loader.vue';

export default {
  props: {
    context: {
      type: Object,
    },
  },

  components: {
    Accordion,
    // FileDropzone,
    Loader,
  },

  mounted() {},

  data() {
    return {
      loading: false,
      imagePreview: null,
      images: [],
      previews: {},
      dropzoneActive: false,
      errors: null,
    };
  },

  computed: {
    value() {
      const ids = [];
      this.images.forEach((image) => {
        if (image.id) {
          ids.push(image.id);
        }
      });
      return ids.length ? ids : null;
    },

    accept: {
      get() {
        const extensions = [];
        if (this.context.attrs.accept) {
          this.context.attrs.accept.split(' ').forEach((ext) => {
            extensions.push(`.${ext}`);
          });
        }
        return extensions.join(',');
      },
    },
  },

  methods: {
    onFileInput(e) {
      this.processFiles(Array.from(e.target.files));
    },

    handleDragEnter() {
      this.dropzoneActive = true;
    },

    handleDragLeave() {
      this.dropzoneActive = false;
    },

    handleDrop(ev) {
      this.dropzoneActive = false;
      this.processFiles(Array.from(ev.dataTransfer.files));
    },

    onImageDelete(id) {
      const image = this.images.filter((i) => i.id === id)[0];
      if (image) {
        this.images.splice(this.images.indexOf(image), 1);
      }
    },

    processFiles(files) {
      this.errors = null;
      files.forEach((file) => {
        if (this.images.length >= this.context.attrs.max) return;
        // add image to array so we can show loading state per image
        const image = {
          id: null,
          preview: null,
          type: file.type,
          name: file.name,
        };

        this.images.push(image);
        // first we check if file is not to big
        if (file.size / 1048576 > Number(this.context.attrs['max-size']) && file.type !== 'image/heic' && file.type !== 'application/pdf') {
          // if size is too big we try to compress the file ->
          /* eslint-disable no-new */
          new Compressor(file, {
            quality: 0.85,
            convertSize: 4000000,
            maxWidth: 2000,
            maxHeight: 2000,
            convertTypes: ['image/png', 'image/webp', 'image/jpg', 'image/gif'],
            success: (result) => {
              const newFile = new File([result], file.name.replace(/\.[^/.]+$/, '.jpg'), {
                type: 'image/jpeg',
                lastModified: new Date().getTime(),
              });
              this.uploadFile(newFile, image);
            },
            error: () => {
              this.showSizeErrors(file);
            },
          });
        } else if (file.type === 'image/heic') {
          this.handleHeicFile(file, image);
        } else if (file.type === 'application/pdf') {
          this.handlePdfFile(file, image);
        } else {
          this.uploadFile(file, image);
        }
      });
    },
    async handleHeicFile(file, image) {
      if (file.size / 1048576 > Number(this.context.attrs['max-size'])) {
        this.showSizeErrors(file);
        this.images.splice(this.images.indexOf(image), 1);
      } else {
        const blob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
        });
        file = new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), {
          type: 'image/jpeg',
          lastModified: new Date().getTime(),
        });
        this.uploadFile(file, image);
      }
    },
    handlePdfFile(file, image) {
      if (file.size / 1048576 > Number(this.context.attrs['max-size'])) {
        this.showSizeErrors(file);
        this.images.splice(this.images.indexOf(image), 1);
      } else {
        this.uploadFile(file, image);
      }
    },
    uploadFile(file, image) {
      const formData = new FormData();
      formData.append(`files[${this.context.node.name}][]`, file);

      fetch(this.context.attrs.api, {
        method: 'POST',
        body: formData,
      })
        .then((r) => r.json())
        .then((fids) => {
          if (fids[this.context.node.name]) {
            if (file.type.indexOf('image') === 0) {
              const reader = new FileReader();
              reader.onload = (event) => {
                [image.id] = fids[this.context.node.name];
                image.preview = event.target.result;
                this.images = [...this.images];
                this.context.images = [...this.images];
              };
              reader.readAsDataURL(file);
            } else {
              [image.id] = fids[this.context.node.name];
              image.preview = true;
              this.images = [...this.images];
              this.context.images = [...this.images];
            }
          } else if (fids.errors) {
            this.images.splice(this.images.indexOf(image), 1);
            this.errors = fids.errors;
          }
        });
    },
    showSizeErrors(file) {
      if (document.documentElement.lang === 'nl') {
        this.errors = [
          {
            message: `De bestandsgrootte van ${file.name} is te groot, de maximale bestandsgrootte is ${this.context.attrs['max-size']} MB`,
          },
        ];
      }
      if (document.documentElement.lang === 'en') {
        this.errors = [
          {
            message: `The file size of ${file.name} is too large, the maximum file size is ${this.context.attrs['max-size']} MB.`,
          },
        ];
      }
      if (document.documentElement.lang === 'fr') {
        this.errors = [
          {
            message: `La taille du fichier ${file.name} est trop grande, la taille maximale autorisée est de ${this.context.attrs['max-size']} Mo.`,
          },
        ];
      }
    },
  },

  watch: {
    value(val) {
      this.context.node.input(val);
    },
  },
};
